module.exports = __webpack_public_path__ + "img/wander3.1880815d.jpg";